
import React, { useState, useEffect } from 'react';
import { Row, Col, Layout, Collapse, message ,Statistic} from 'antd';
import { searchService } from './services/';
import { PDF_API_REL, FILTERS_API_REL } from './constants';
import { DatesPicker, InputBox, SelectBoxsContainer, TableBox, PanelBox, AutoCompleteBox, PanelHeader } from './components/index';
import 'antd/dist/antd.css';
import './App.css';

const { Content } = Layout;

const App = (props) => {
  const [filters, setFilters] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [decisions, setDecisions] = useState([]);
  const [isShowSpin, setIsShowSpin] = useState(false);  
  const [count, setCount] = useState(0);
  const [linksForHATEOAS, setlinksForHATEOAS] = useState([]);
  const [constraints, setConstraints] = useState({
    decisionStartDate: null,
    decisionEndDate: null,
    decisionCriterias: []
  });

  useEffect(() => { getDecisionObjects(); }, []);

  useEffect(() => {
    combinedConstraintSearch(constraints);
  }, [constraints]); // eslint-disable-line react-hooks/exhaustive-deps

  const getRequestUrl = (rel) => linksForHATEOAS.filter(l => l.rel === rel)[0];


  const getFilters = () => {
    try {
      searchService.getFilters(getRequestUrl(FILTERS_API_REL).href).then(res => {
        setFilters(res.data.data);
      })
    } catch (error) {
      message.error('Error fetching filters.');
      console.error(error);
    }
  };

  const pdfTextSearchCall = (pdfText) => {
    setIsShowSpin(true);
    if (pdfText === '') {
      setTableData([]);
      hideSpinner();
    }
    try {
      const linkObject = getRequestUrl(PDF_API_REL);
      searchService.getResultsByPdfText(linkObject.href, linkObject.queryStrings, true, pdfText).then(res => {
        mapPdfToDecisions(res.data);
        hideSpinner();
      });
    } catch (error) {
      message.error('PDF search failed.');
      console.error(error);
    }
  };

  const mapPdfToDecisions = (res) => {
    const pdfArray = res.data ? res.data : [];
    const decisionData = pdfArray.map(p => decisions.filter(d => d.decisionPdfUrl === p.url)[0]);
    setTableData(decisionData.map(d => ({
      name: d.decisionName,
      url: d.decisionPdfUrl
    })));     
    setCount(decisionData.length);
  }

  const hideSpinner = () => {
    setTimeout(() => {
      setIsShowSpin(false);
    }, 1000);
  }

  const getDecisionObjects = () => {
    try {
      searchService.getDecisions().then(res => {
        setDecisions(res.data.data);
        setlinksForHATEOAS(res.data.links);
      })
    } catch (error) {
      message.error('Error fetching decisions.');
      console.error(error);
    }
  }

  const onChangeCollapse = (keys) => {
    if (keys.length !== 0 && (keys.includes("3")) && filters.length === 0) {
      getFilters();
    }
  }

  const updateTableData = (data) => {
    setIsShowSpin(true);
    setTableData(data);
    setCount(data.length);    
    hideSpinner();
  }

  const updateConstraints = (data) => {
    if (data.startDate || data.startDate === '') {
      setConstraints((prevState) => ({
        ...prevState, decisionStartDate: data.startDate,
        decisionEndDate: data.endDate
      }));
    } else {
      setConstraints((prevState) => ({
        ...prevState,
        decisionCriterias: getNewCriterias(prevState, data).filter(d => d.filterValues.length !== 0)
      }));
    }
  }

  const getNewCriterias = (prevState, data) => {
    const oldDecisionCriterias = prevState.decisionCriterias;
    const newObject = {
      filterName: data.filterName,
      filterValues: data.values
    };
    if (oldDecisionCriterias && oldDecisionCriterias.some(o => o.filterName === data.filterName)) {
      return [...oldDecisionCriterias.filter(o => o.filterName !== data.filterName), newObject]
    } else {
      return [...oldDecisionCriterias, newObject];
    }
  }

  const onSwitchChange = (switchObject) => {
    setConstraints((prevState) => ({
      ...prevState, ...switchObject
    }))
  }

  const combinedConstraintSearch = (constr) => {
    const isDateSearchOnly = constr.decisionEndDate && !constr.decisionCriterias.length > 0;
    const isFilterSearchOnly = !constr.decisionEndDate && constr.decisionCriterias.length > 0;
    const noDateAndFilterSearchValue = !constr.decisionEndDate && !constr.decisionCriterias.length > 0;
    const matchDecisions = [];
    if (noDateAndFilterSearchValue) {
      updateTableData([]);
    } else if (isDateSearchOnly) {
      for (let d of decisions) {
        if (isDecisionDateOverlap(d, constr)) {
          matchDecisions.push(d);
        }
      }
    } else if (isFilterSearchOnly) {
      for (let d of decisions) {
        if (isCriteriaOverlap(constr, d.decisionCriterias)) {
          matchDecisions.push(d);
        }
      }
    } else {
      for (let d of decisions) {
        if (isDecisionDateOverlap(d, constr) && isCriteriaOverlap(constr, d.decisionCriterias)) {
          matchDecisions.push(d);
        }
      }
    }
    updateTableData(matchDecisions.map(v => ({
      name: v.decisionName,
      url: v.decisionPdfUrl
    })));
  }

  const isCriteriaOverlap = (constraintsClone, currentDecisionCriterias) => {
    const acrossFiltersMatched = [];
    for (let cri of constraintsClone.decisionCriterias) {
      const isCurrentFilterMatched = currentDecisionCriterias.some(value => cri.filterValues.includes(value)); 
      acrossFiltersMatched.push(isCurrentFilterMatched);
    }
    return acrossFiltersMatched.every(value => value === true);
  }

  const isDateOverlap = (StartA, EndA, StartB, EndB) => {
    const getT = (t) => new Date(t)
    console.log(getT(StartA), getT(EndA), getT(StartB), getT(EndB))
    return !(getT(EndA) <= getT(StartB) || getT(StartA) >= getT(EndB))
  }

  const isDecisionDateOverlap = (d, con) => {

    return isDateOverlap(d.decisionStartDate, d.decisionEndDate,
      con.decisionStartDate, con.decisionEndDate)
  }

  const panelObjects = [
    {
      component: <InputBox placeholder="keyword" pdfTextSearchCall={pdfTextSearchCall} />,
      headerText: "Keyword Search",
      tooltip: "Search by keyword."
    },
    {
      component: <AutoCompleteBox placeholder="Decision number and name search" options={decisions}
        setTableData={updateTableData} />,
      headerText: "Decision name or number",
      tooltip: "Look up a Decision"
    },
    {
      component: <DatesPicker updateConstraints={updateConstraints} />,
      headerText: "Decision date",
      tooltip: "Search by decision date."
    },
    {
      component: <SelectBoxsContainer filters={filters} updateConstraints={updateConstraints} />,
      headerText: "Filter decisions",
      tooltip: "Filter decisions."
    }
  ].map((p, i) => ({
    component: p.component,
    header: <PanelHeader headerText={p.headerText} tooltip={p.tooltip} />
  }));
  return (
    <div className="App">
      <Layout className="layout">      
        <Content className="content">          
          <div className="site-layout-content">
            <Row gutter={16}>
              <Col xs={22} sm={22} md={12} lg={12} xl={12} className="col-12">                
                <Collapse defaultActiveKey={['0']} onChange={onChangeCollapse}>
                  {panelObjects.map((v, i) =>
                    <PanelBox key={i} onSwitchChange={onSwitchChange} header={v.header} >{v.component}</PanelBox>
                  )}
                </Collapse>
              </Col>
              <Col xs={22} sm={22} md={12} lg={12} xl={12} className="col-12">               
                <TableBox tableData={tableData} isShowSpin={isShowSpin} />              
                <Statistic value={count} suffix={' matches from ' + decisions.length + ' decisions'} valueStyle={{ fontSize: '3em' }} />             
              </Col>
            </Row>                     
          </div>          
        </Content>
      </Layout>
    </div>
  );
}

export default App;
